import { Component, Input, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { FadeIn, direction } from 'projects/exi-ui/src/lib/animations/animations';
import { STUB_FN_FALSE } from 'projects/exi-ui/src/lib/utils/stubs';
import { getGlobalOrLocalCssVar } from 'projects/exi-ui/src/lib/utils/cssVarGetter.func';
import { Viewport } from '../../utils/viewport';

@Component({
   selector: 'app-options',
   styleUrls: ['./options.component.scss'],
   animations: [FadeIn],
   template: `
      <section class="wrapper {{ this.ctx.style }}" #Wrapper>
         <div class="options">
            <button  *ngFor="let option of options" 
                     (click)="ctx.select(option)"
                     (blur)="ctx.onBlur($event)"
                     [ngClass]="{ 'selected': ctx.isSelected(option) }"
                     [disabled]="ctx.isDisabled(option)"
                     [title]="ctx.title(option)"
                     class="option {{ ctx.title(option) }}">
               <span class="text-cutter" tooltip>{{ ctx.title(option) }}</span>
            </button>
         </div>
      </section>
   `,
})
export class OptionsComponent<D> implements OnInit, AfterViewInit, OnDestroy {
   @Input() public ctx: Options<D>;
   @ViewChild('Wrapper') wrapper: ElementRef<HTMLDivElement>;
   public viewport: Viewport<D>;
   public options: D[] = [];
   public sbcr: Subscription;
   private visibleCount: number;

   ngOnInit() {
      this.ctx.style = this.ctx.style || 'default';
      this.ctx.onBlur = this.ctx.onBlur || STUB_FN_FALSE;
      this.ctx.isDisabled = this.ctx.isDisabled || STUB_FN_FALSE;
      this.ctx.isSelected = this.ctx.isSelected || STUB_FN_FALSE;
      this.visibleCount = this.ctx.style === 'default' ? 5 : 9;
      this.viewport = new Viewport(this.visibleCount);
   }

   ngAfterViewInit() {
      const wrapper = this.wrapper.nativeElement;
      const itemHeight = getGlobalOrLocalCssVar('--exi-options-item-height', wrapper);

      this.viewport.setHost(wrapper, itemHeight);
      this.sbcr = this.ctx.stream.subscribe(options => {
         requestAnimationFrame(() => {
            this.options = this.viewport.build(options);
            console.log(options, this.options)
         });
      });
   }

   ngOnDestroy() {
      this.sbcr.unsubscribe();
   }

   direction() {
      return direction(this.viewport.prevDirection);
   }
}

export interface Options<D> {
   stream: Observable<D[]>;
   select: (option: D) => void;
   title: (option: D) => string;
   isSelected?: (option: D) => boolean;
   isDisabled?: (option: D) => boolean;
   style?: OptionsStyle;
   onBlur?: (e: FocusEvent) => void;
}

export type OptionsStyle = 'default' | 'static' | 'colors';

